import { SIDEBAR_SUCCESS, RESET_SIDEBAR } from "../types";

const resetSidebar = () => {
  return {
    type: RESET_SIDEBAR,
  };
};

// const getSidebar = (data) => {
//   console.log("sidebarAction", data)
//   return {
//     type: SIDEBAR_SUCCESS,
//     payload: data,
//   };
// };

const getSidebar = (data) => async (dispatch) => {
  return dispatch({
    type: SIDEBAR_SUCCESS,
    payload: data,
  });
};

export { resetSidebar, getSidebar };
